import { BaseFactory } from './BaseFactory';
import { V1 as StoreV1 } from '../Models/Stores/V1';

export class Stores extends BaseFactory
{
	protected _storeObjs={};
	
	public getById(id, throwOnErr=false)
	{
		if (typeof this._storeObjs[id] != "undefined") {
			return this._storeObjs[id];
		} else if (throwOnErr === true) {
			throw this.getMtm().newException("Id" + id + ", does not exist");
		} else {
			return null;
		}
	}
	public getV1(id, auth=null, cObj=null)
	{
		if (typeof this._storeObjs[id] == "undefined") {
			this._storeObjs[id]	= new StoreV1();
			this._storeObjs[id].setService(this.getService()).setConfig(cObj, id, auth);
			this._storeObjs[id].setExceptionCb(this.getService().getLogging(), "exception");
		}
		return this._storeObjs[id];
	}
	public getByClient(cObj)
	{
		var rObjs		= [];
		var storeObj	= null;
		var ids	= Object.keys(this._storeObjs);
		for (let id of ids) {
			storeObj	= this._storeObjs[id];
			if (storeObj.getClient().getGuid() === cObj.getGuid()) {
				rObjs.push(storeObj);
			}
		}
		return rObjs;
	}
	public async clearCache(obj)
	{
		if (typeof this._storeObjs[obj.getDdsId()] != "undefined") {
			delete this._storeObjs[obj.getDdsId()];
		}
		return this;
	}
}